import { render, staticRenderFns } from "./CollizionCheckComponent.vue?vue&type=template&id=83d5997e&scoped=true&"
import script from "./CollizionCheckComponent.vue?vue&type=script&lang=js&"
export * from "./CollizionCheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollizionCheckComponent.vue?vue&type=style&index=0&id=83d5997e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d5997e",
  null
  
)

export default component.exports